function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12 .54C5.68.54.54 5.68.54 12c0 6.32 5.14 11.46 11.46 11.46 6.32 0 11.46-5.14 11.46-11.46C23.46 5.68 18.32.54 12 .54zm0 21.72c-5.66 0-10.26-4.6-10.26-10.26S6.34 1.74 12 1.74 22.26 6.34 22.26 12c.01 5.66-4.6 10.26-10.26 10.26z",
  fill: "#F66132"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.03 7.98a.61.61 0 00-.85 0L12 11.16 8.82 7.98a.61.61 0 00-.85 0 .6.6 0 000 .85l3.18 3.18-3.18 3.18a.61.61 0 000 .85c.12.12.27.18.42.18.15 0 .31-.06.42-.18l3.18-3.18 3.18 3.18c.12.12.27.18.42.18.15 0 .31-.06.42-.18a.61.61 0 000-.85l-3.18-3.18 3.18-3.18c.25-.24.25-.62.02-.85z",
  fill: "#F66132"
});

function SvgRejectIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "3b0c387ed872a33856ac2edc30cc089d.svg";
export { SvgRejectIcon as ReactComponent };